const initialState = {
  servicesHome: [],
  isLoading: null,
  isError: null,
};

export default initialState;
